<script>
import {mapState} from 'vuex'

export default {
    data() {
        return {
            data : null,
        }
    },
    
    props: ['url',],


    computed: {
    },

    created() {
    },

    mounted() {
        this.getData();
    },

    watch: {
    },

    methods: {
        getData() {
            axios
                .get(this.url,
                    {
                        params: {
                        }
                    }
                )
                .then(response => {
                    this.data = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                });
        },

        deleteItem(url, index) {
            axios
                .delete(url)
                .then(response => {
                    this.data.splice(index, 1);
                    this.$root.$refs.toastr.s(response.data.message);
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },

        toggleActive(item) {
            axios
                .put(item.toggle_url)
                .then(response => {
                    item.active = !item.active;
                    this.$root.$refs.toastr.s(response.data.message);
                })
                .catch(error => {
                    console.log(error);
                    this.$root.$refs.toastr.e("ERROR");
                });
        },
    },
}
</script>